<template>
    <div class="assetInfo">
        <div class="data-title" v-if="phoneList.length">
            <h3>我的手机工作号<el-tag class="tag" type="success">{{ phoneList.length }}</el-tag></h3>
            <lb-table class="table" v-horizontal-scroll="'always'" :column="columns" :data="phoneList">
            </lb-table>
        </div>
        <div class="data-title" v-if="wechatList.length">
            <h3>我的工作微信号<el-tag class="tag" type="success">{{ wechatList.length }}</el-tag></h3>
            <lb-table class="table" v-horizontal-scroll="'always'" :column="columns1" :data="wechatList">
            </lb-table>
        </div>
        <div class="data-title" v-if="qqList.length">
            <h3>我的工作QQ号<el-tag class="tag" type="success">{{ qqList.length }}</el-tag></h3>
            <lb-table class="table" v-horizontal-scroll="'always'" :column="columns2" :data="qqList">
            </lb-table>
        </div>
        <div class="data-title" v-if="emailList.length">
            <h3>我的工作邮箱<el-tag class="tag" type="success">{{ emailList.length }}</el-tag></h3>
            <lb-table class="table" v-horizontal-scroll="'always'" :column="columns3" :data="emailList">
            </lb-table>
        </div>
        <div class="data-title" v-if="accountList.length">
            <h3>我的平台账号<el-tag class="tag" type="success">{{ accountList.length }}</el-tag></h3>
            <lb-table class="table" v-horizontal-scroll="'always'" :column="columns4" :data="accountList">
            </lb-table>
        </div>
        <pop-Remark ref="popRemark" @setRemark="saveRemark" />
    </div>
</template>
<script>
import LbTable from "@/components/lb-table/lb-table";
import popRemark from "@/pages/assetManagement/common/popRemark";
export default {
    name: 'assetInfo',
    components: { LbTable, popRemark },
    props: {
        detail: {
            type: Object,
            required: true, // 必选
            default: () => ({})
        }
    },
    data() {
        return {
            phoneList: [],
            emailList: [],
            qqList: [],
            wechatList: [],
            accountList: [],
            remarkRow: null,
            remarkType: '',
            columns: [],
            columns1: [],
            columns2: [],
            columns3: [],
            columns4: [],
            accountTypeList: [
                { dictId: '0', dictName: '主账号' },
                { dictId: '1', dictName: '子账号' },
            ],
            usingStatusList: [
                { dictId: '1', dictName: '使用中' },
                { dictId: '2', dictName: '已停用' },
            ],
        }
    },
    created() {
        this.initColumns()
        this.getDate()
    },
    methods: {
        initColumns() {
            // 审批状态列
            const statusColumn = {
                label: '审批状态', prop: 'actStatusName', minWidth: '100',
                render: (h, scope) => {
                    const { actStatus, actStatusName } = scope.row;
                    return (
                        <div class='align-left'>
                            <span class={`icon-act-status icon-act-status-${actStatus}`}></span>{actStatusName}
                        </div>
                    )
                }
            }

            // 备注列生成函数
            const createRemarksColumn = (label) => ({
                label: `${label}备注`, prop: 'remarks', minWidth: '450',
                render: (h, scope) => {
                    return (
                        <div class='ellipsis2' title={scope.row.remarks}>{scope.row.remarks ? scope.row.remarks : "-"}</div>
                    )
                }
            })

            // 操作列生成函数
            const createActionsColumn = (type) => ({
                label: '操作', prop: 'phone', minWidth: '130', fixed: 'right',
                render: (h, scope) => (
                    <div style="display:flex;">
                        <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookDetail(scope.row, type) }} >查看/编辑</div>
                        <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.setRemark(scope.row, type) }} >备注</div>
                    </div>
                )
            })

            // 序号列生成函数
            const createSerialColumn = (label) => ({
                prop: 'phone', width: '150',
                render: (h, scope) => {
                    const index = scope.$index + 1;
                    const displayIndex = index < 10 ? `0${index}` : index;
                    return (
                        <div>{label + displayIndex}</div>
                    )
                }
            })

            // 手机号列
            this.columns = [
                createSerialColumn('工作手机号'),
                {
                    label: '工作手机号', prop: 'phone', minWidth: '120',
                    render: (h, scope) => (<div class='ellipsis2'>{scope.row.phone ? scope.row.phone : "-"}</div>)
                },
                {
                    label: '运营商', prop: 'phoneOperatorName', minWidth: '74',
                    render: (h, scope) => (<div>{scope.row.phoneOperatorName ? scope.row.phoneOperatorName : "-"}</div>)
                },
                statusColumn,
                createRemarksColumn('手机号'),
                createActionsColumn('phone')
            ]

            // 微信号列
            this.columns1 = [
                createSerialColumn('工作微信号'),
                {
                    label: '工作微信号', prop: 'wechat', minWidth: '120',
                    render: (h, scope) => (<div class='ellipsis2'>{scope.row.wechat ? scope.row.wechat : "-"}</div>)
                },
                {
                    label: '绑定手机号', prop: 'bindPhone', minWidth: '120',
                    render: (h, scope) => (<div class='ellipsis2'>{scope.row.bindPhone ? scope.row.bindPhone : "-"}</div>)
                },
                statusColumn,
                createRemarksColumn('微信号'),
                createActionsColumn('wechat')
            ]

            // QQ号列
            this.columns2 = [
                createSerialColumn('工作QQ号'),
                {
                    label: '工作QQ号', prop: 'qq', minWidth: '120',
                    render: (h, scope) => (<div class='ellipsis2'>{scope.row.qq ? scope.row.qq : "-"}</div>)
                },
                {
                    label: '绑定手机号', prop: 'bindPhone', minWidth: '120',
                    render: (h, scope) => (<div class='ellipsis2'>{scope.row.bindPhone ? scope.row.bindPhone : "-"}</div>)
                },
                statusColumn,
                createRemarksColumn('QQ号'),
                createActionsColumn('qq')
            ]

            // 邮箱列
            this.columns3 = [
                createSerialColumn('工作邮箱'),
                {
                    label: '工作邮箱', prop: 'email', minWidth: '180',
                    render: (h, scope) => (<div class='ellipsis2'>{scope.row.email ? scope.row.email : "-"}</div>)
                },
                {
                    label: '绑定手机号', prop: 'bindPhone', minWidth: '120',
                    render: (h, scope) => (<div class='ellipsis2'>{scope.row.bindPhone ? scope.row.bindPhone : "-"}</div>)
                },
                statusColumn,
                createRemarksColumn('邮箱'),
                createActionsColumn('email')
            ]

            // 平台账号列
            this.columns4 = [
                createSerialColumn('平台账号'),
                {
                    label: '平台账号', prop: 'accounts', minWidth: '180',
                    render: (h, scope) => (<div class='ellipsis2'>{scope.row.accounts ? scope.row.accounts : "-"}</div>)
                },
                {
                    label: '所属平台', prop: 'platformName', minWidth: '88',
                    render: (h, scope) => (<div>{scope.row.platformName ? scope.row.platformName : "-"}</div>)
                },
                {
                    label: '角色', prop: 'roleList', minWidth: '150',
                    render: (h, scope) => (<div class='ellipsis2'>{scope.row.roleList ? scope.row.roleList : "-"}</div>)
                },
                statusColumn,
                {
                    label: '使用状态', prop: 'usingStatus', minWidth: '88',
                    render: (h, scope) => {
                        const status = this.usingStatusList.find(item => item.dictId == scope.row.usingStatus);
                        const statusName = status ? status.dictName : "-";
                        return (<div title={statusName}>{statusName}</div>)
                    }
                },
                {
                    label: '账号类型', prop: 'accountTypes', minWidth: '88',
                    render: (h, scope) => {
                        const { accountType } = scope.row
                        if (!accountType || !Array.isArray(accountType) || accountType.length === 0) {
                            return (<div>-</div>)
                        }
                        const typeNames = accountType
                            .map(typeId => {
                                const type = this.accountTypeList.find(item => item.dictId == typeId)
                                return type ? type.dictName : null
                            })
                            .filter(Boolean)
                            .join('、')

                        return (<div class='ellipsis2' title={typeNames}>{typeNames || '-'}</div>)
                    }
                },
                createRemarksColumn('账号'),
                createActionsColumn('account')
            ]
        },
        getDate() {
            this.axios.get('/oa/sys/user/personProperty').then((res) => {
                if (res.code == 0) {
                    this.phoneList = res.data.phoneList || []
                    this.emailList = res.data.emailList || []
                    this.qqList = res.data.qqList || []
                    this.wechatList = res.data.wechatList || []
                    this.accountList = res.data.accountList || []
                }
            })
        },
        // 备注
        setRemark(val, type) {
            this.remarkRow = val
            this.remarkType = type
            this.$refs.popRemark.show(val.remarks || '')
        },
        // 保存备注回调
        async saveRemark(newRemark) {
            let apiFn = null
            let params = {
                id: this.remarkRow.id,
                remarks: newRemark.remarks
            }
            console.log('修改的备注', params);
            const apiMap = {
                phone: this.$api.workPhoneRemark,
                wechat: this.$api.workWechatRemark,
                qq: this.$api.workQQRemark,
                email: this.$api.workEmailRemark,
                account: this.$api.platformAccountRemark
            };
            apiFn = apiMap[this.remarkType];

            if (apiFn) {
                const res = await apiFn(params)
                if (res.code == 0) {
                    this.$message.success('修改备注成功')
                    this.getDate()
                } else {
                    this.$message.error('修改备注失败')
                }
            }
        },
        lookDetail(val, type) {
            const pathMap = {
                phone: 'assetManagement/workPhone/detail',
                wechat: 'assetManagement/workWechat/detail',
                qq: 'assetManagement/workQQ/detail',
                email: 'assetManagement/workEmail/detail',
                account: 'assetManagement/platformAccount/detail'
            };
            const path = pathMap[type];

            console.log('前往的路径', path);
            console.log('数据', val);

            if (path) {
                this.$router.push({ path: path, query: { id: val.id } })
            }
        },
    }
}
</script>
<style lang="scss" src="@/pages/info/common/style/list.scss" scoped />
<style lang="scss">
.table {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #2F3030;



    // 审批状态 1无审批 2审批中 3审批通过 4驳回
    .icon-act-status {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-top: 9px;
        margin-right: 4px;
    }

    .icon-act-status-1 {
        border: 1px solid #C5C9C9;
        box-sizing: border-box;
    }

    .icon-act-status-2 {
        background: #F5C401;
    }

    .icon-act-status-3 {
        background: #00B498;
    }

    .icon-act-status-4 {
        background: #E23C58;
    }

    .icon-act-status-5 {
        background: #C5C9C9;
    }

}
</style>